export default __webpack_public_path__ + "static/media/carli.f9c13f4d.jpg";